import type { User } from '@/types'

export function isPodTransporter(user?: User | null): boolean {
  return String(user?.pod_role || '').toLowerCase() === 'pod transporter'
}

export function isPodItAdmin(user?: User | null): boolean {
  return String(user?.pod_role || '').toLowerCase() === 'pod it admin'
}

export function isPodViewer(user?: User | null): boolean {
  return String(user?.pod_role || '').toLowerCase() === 'pod viewer'
}

/** First route after login — mirrors legacy POD-WEB (role 14 → pending upload). */
export function defaultAuthedPath(user?: User | null): string {
  if (isPodTransporter(user)) return '/transporter/pending-upload'
  return '/dashboard'
}
